import { useEffect, useState, type ComponentPropsWithoutRef } from 'react'

import { styled } from 'styled-components'

import { Tooltip } from '@b-stock/fe-core/bstock-react'
import { Colors, pxToRem } from '@b-stock/fe-core/design-system'

export type ErrorTooltipProps = Omit<
  ComponentPropsWithoutRef<typeof Tooltip>,
  'children' | 'isOpen'
> & { referenceElement: HTMLElement }

const ARROW_SIZE = pxToRem(7)

export const ErrorTooltip = styled(Tooltip)`
  background: ${Colors.Semantic.Error.highlight};
  color: ${Colors.Semantic.Neutral.white};
  position: relative;

  &::after {
    background: ${Colors.Semantic.Error.highlight};
    content: '';
    height: ${ARROW_SIZE};
    left: 50%;
    position: absolute;
    top: 0;
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    width: ${ARROW_SIZE};
    z-index: 1;
  }
`

export const TOOLTIP_AUTO_DISMISS_MS = 6_000

export const useErrorTooltip = () => {
  const [errorTooltip, setErrorTooltip] = useState<ErrorTooltipProps | null>(
    null
  )
  const [errorTooltipMessage, setErrorTooltipMessage] = useState<string | null>(
    null
  )
  useEffect(() => {
    if (!errorTooltipMessage) return
    const id = setTimeout(
      () => setErrorTooltipMessage(null),
      TOOLTIP_AUTO_DISMISS_MS
    )
    return () => clearTimeout(id)
  }, [errorTooltipMessage])

  return {
    errorTooltip,
    setErrorTooltip,
    errorTooltipMessage,
    setErrorTooltipMessage,
  }
}
